export default {
  organizationLogo: 'Organization logo',
  "configTitle": "User verification settings",
  "personal": "Personal verification",
  "enterprise": "Organization verification",
  "personalDesc": "Verify individual identity to improve account trust.",
  "enterpriseDesc": "Verify organizations, associations and institutions using registration documents and legal representative details.",
  "enterpriseMaterials": "Required documents for organizations and associations",
  "materials": "Application materials",
  "verified": "Verified",
  "pending": "Pending",
  "unverified": "Unverified",
  "materialsConfig": "Configure materials",
  "rules": "⚙ Review rules",
  "reviewMode": "Review method",
  "manual": "Manual review",
  "deadline": "Review deadline",
  "unset": "Not set",
  "validity": "Verification validity",
  "permanent": "Permanent",
  "notifications": "Notify automatically on approval",
  "sms": "SMS (unavailable)",
  "email": "Email",
  "site": "In-app message (unavailable)",
  "instruction": "Instructions shown to applicants",
  "save": "Save settings",
  "materialsHint": "Configure the materials applicants must submit.",
  "reorderHint": "Drag to reorder; click × to remove",
  "drag": "Drag to reorder",
  "materialName": "Material name",
  "text": "Single-line text",
  "textarea": "Multiline text",
  "select": "Dropdown",
  "image": "Image",
  "required": "Required",
  "optional": "Optional",
  "system": "System",
  "emptyMaterials": "No materials yet. Add one below.",
  "newMaterial": "New material name",
  "add": "Add",
  "tip": "💡 Material types determine the form controls applicants see. Removing a material does not delete previously submitted data.",
  "cancel": "Cancel",
  "enterMaterial": "Enter a material name",
  "saved": "Verification settings saved",
  "reviewTitle": "Verification reviews",
  "reviewed": "Reviewed",
  "pendingApplications": "Pending applications",
  "reviewHint": "Select Approve or Reject to complete a review",
  "approved": "Approved",
  "rejected": "Rejected",
  "status": "Status",
  "type": "Type",
  "startDate": "Start date",
  "endDate": "End date",
  "search": "Search application ID / applicant",
  "applicationNo": "Application ID",
  "applicant": "Applicant / organization",
  "verificationType": "Verification type",
  "submittedAt": "Submitted at",
  "reviewer": "Reviewer",
  "reviewedAt": "Reviewed at",
  "result": "Review result",
  "reasonPrefix": "Rejection reason: ",
  "actions": "Actions",
  "viewMaterials": "View materials",
  "details": "Details",
  "approve": "Approve",
  "reject": "Reject",
  "reviewStatus": "Review status",
  "submittedMaterials": "Submitted materials",
  "close": "Close",
  "rejectTitle": "Reject verification",
  "rejectHint": "Provide a rejection reason so the applicant can revise and resubmit.",
  "enterReason": "Enter the rejection reason",
  "confirmReject": "Confirm rejection",
  "approveTitle": "Approve verification",
  "confirmApprove": "Confirm approval",
  "approveSuccess": "Verification application approved",
  "reviewFailed": "Review failed",
  "reasonRequired": "Provide a rejection reason",
  "rejectSuccess": "Verification application rejected",
  "verification": "Verification status",
  "standard": "Standard",
  "realName": "Verified",
  "underReview": "Under review",
  "pendingDesc": "The application is under manual review. A verification badge will be granted upon approval.",
  "rejectedDesc": "The application was rejected. The applicant can update the materials and resubmit.",
  "unverifiedDesc": "This user has not completed identity verification.",
  "noPlan": "Plan information is unavailable.",
  "planDefault": "Features configured for the current plan are available.",
  "days": "{n} days",
  "materialsTitle": "{type} · Application materials",
  "materialCount": "Application materials ({n})",
  "duplicate": "“{name}” already exists. Do not add it again.",
  "materialsSaved": "Saved materials for {type} ({n} items)",
  "totalRecords": "{n} records",
  "detailTitle": "Verification materials · {name}",
  "approvePrompt": "Approve the verification application for “{name}”? The user and organization names will also be updated.",
  "approvedPersonal": "Personal identity verified. The corresponding plan benefits are available.",
  "approvedEnterprise": "Organization identity verified. The corresponding plan benefits are available.",
  "planBenefits": "{name} plan benefits: {text}",
  "companyCount": "{n} companies",
  "featureSeparator": ", ",
  "organizationName": "Organization name",
  "systemRealName": "Full name"
}
